import styled from 'styled-components'
import { color } from '../../../../GlobalStyle'
import { breakpoints } from '../../../../MediasQueries'

export const ModalDivInput = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
    row-gap: 15px;
  }
  @media (max-width: ${breakpoints.sm}) {
    row-gap: 5px;
  }
  column-gap: 30px;
  row-gap: 20px;
  label {
    font-size: 12px;
  }
`

export const Item = styled.div`
  grid-row: span 2;
  grid-column: span 2;
  @media (max-width: ${breakpoints.md}) {
    grid-column: span 1;
    row-gap: 15px;
  }
  @media (max-width: ${breakpoints.sm}) {
    row-gap: 5px;
  }
`
export const Components = styled.div`
  display: grid;

  grid-template-columns: repeat(auto-fit, minmax(40px, 110px));
  @media (max-width: ${breakpoints.sm}) {
    grid-template-columns: repeat(3, minmax(40px, 1fr));
  }
  gap: 10px;
`
export const Half = styled.div`
  grid-column: span 2;
  row-gap: 20px;
  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
    grid-column: span 1;
    row-gap: 15px;
  }
  @media (max-width: ${breakpoints.sm}) {
    row-gap: 5px;
  }
  display: grid;
  column-gap: 30px;
  grid-template-columns: 1fr 2fr;
`
export const Adicional = styled.div`
  display: grid;
`
export const AdicionalItem = styled.div`
  background-color: ${color.brand};
  padding: 10px;
  border-radius: 360px;
  color: #fff;
  display: flex;
  justify-content: center;
  font-weight: bold;
  align-items: center;
  font-size: 15px;
`
